import { IncomingMessage } from "http"

interface SitecoreIncomingMessage {
  _sitecoreIntegrated?: boolean
}

declare module "http" {
  interface IncomingMessage extends SitecoreIncomingMessage {}
}

export function isSitecoreRequest (req: IncomingMessage): boolean {
  return req && !!req._sitecoreIntegrated
}
